export default {spreads:{BaseStorableSummary:{}}}